// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1myTt","questions":"styles_questions__3nOlz","footer":"styles_footer__26i9R"};